export default __webpack_public_path__ + "static/media/wuerthbold_webfont3_2.c35a9115.woff2";